module.exports = __webpack_public_path__ + "static/img/12.c714811.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/12.png
// module id = P3Yr
// module chunks = 0